exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.percent-indicator[data-v-27d1ca7a] {\r\n  width: 120px;\r\n  height: 120px;\n}\r\n", ""]);

// exports
